module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header-tab"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "item",
      class: {
        'active': _vm.selectedId === parseInt(item.id)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selected(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getTabName(item)) + "\n    ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-arrow-left-menu.svg",
      "alt": "prev"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-arrow-right-menu.svg",
      "alt": "next"
    }
  })])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e13c096c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubHeaderTab.vue
// module id = 1615
// module chunks = 1